import pie from './pie';
import {clone} from "../common/js/tool";
let sex = clone(pie);
sex.name = '性别分布';
sex.series[0].data = [
    {value: 40, name: '女'},
    {value: 60, name: '男'}
];
export default sex;
